import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ImageContainer from '../../components/ui/ImageContainer';
import { LANGUAGE } from '../../constants/localStorage';
import { getData } from '../../services/storage';
import { getLocaleString } from '../../utils/locales';

const OurPartner = () => {
  const locale = getData(LANGUAGE);
  // const buyGoldImage = locale === 'en' ? '/image/partner/buyGoldddd.png' : '/image/partner/buyGoldBn.png'
  const [hoverImage, setHoverImage] = useState(`${getLocaleString('home_partner_image_1', locale)}`);

    useEffect(() => {
    setHoverImage(`${getLocaleString('home_partner_image_1', locale)}`)
  },[locale]);

  
  return (
    <div className="flex items-center justify-center w-full">
      <div>
        <div>
          <p className="text-center text-xl lg:text-3xl font-bold text-[#010103]/80">
            {getLocaleString('our_official_partners', locale)}
          </p>
          <div className="flex items-center justify-center mt-10 h-auto lg:max-h-48 w-auto">
            
                <ImageContainer src="/image/partner/Partner-Logo-2.jpg" alt="Logo Strip" className="h-[70px] lg:h-[220px]" />
                

              
          </div>
        </div>
        <div className="flex items-center justify-center w-full mt-12 px-9 md:px-24 lg:mt-20">
          <div className="flex flex-col-reverse lg:flex-row">
            <div className="flex items-center justify-center w-full mt-8 mr-0 lg:mr-22 lg:w-1/2 lg:mt-0">
              <ImageContainer src={hoverImage} alt="gold" className="w-100vh h-100vh" />
            </div>
            <div className="w-full mb-10 lg:mb-0 lg:w-1/2">
              <p className="text-3xl font-semibold capitalize text-[#010103]/80 md:text-4xl">
                {getLocaleString('live_life_gold_standard', locale)}
              </p>
              <div
                className="pt-10"
                onMouseEnter={(e) => {
                  setHoverImage(`${getLocaleString('home_partner_image_1', locale)}`);
                }}
                // onMouseLeave={(e) => {
                //   setHoverImage('image/partner/phone.svg');
                // }}
              >
                <p className="text-2xl font-semibold text-[#010103]/80 hover:text-[#e9be5a]">
                  {getLocaleString('buy_gold', locale)}
                </p>
                <p className="text-[#010103]/54 py-2 text-base font-normal">
                  {getLocaleString('buy_gold_details', locale)}
                </p>
              </div>
              <div
                className="py-6"
                onMouseEnter={(e) => {
                  setHoverImage(`${getLocaleString('home_partner_image_2', locale)}`);
                }}
                // onMouseLeave={(e) => {
                //   setHoverImage('image/partner/phone.svg');
                // }}
              >
                <p className="text-2xl font-semibold text-[#010103]/80 hover:text-[#e9be5a]">
                  {getLocaleString('sell_gold', locale)}
                </p>
                <p className="text-[#010103]/54 py-2 text-base font-normal">
                  {getLocaleString('sell_gold_details', locale)}
                </p>
              </div>
              <div
                className="pb-6"
                onMouseEnter={(e) => {
                  setHoverImage(`${getLocaleString('home_partner_image_3', locale)}`);
                }}
                // onMouseLeave={(e) => {
                //   setHoverImage('image/partner/phone.svg');
                // }}
              >
                <p className="text-2xl font-semibold text-[#010103]/80 hover:text-[#e9be5a]">
                  {getLocaleString('collect_gold', locale)}
                </p>
                <p className="text-[#010103]/54 py-2 text-base font-normal">
                  {getLocaleString('collect_gold_details', locale)}
                </p>
              </div>
              <div
                className="pb-6"
                onMouseEnter={(e) => {
                  setHoverImage(`${getLocaleString('home_partner_image_4', locale)}`);
                }}
                // onMouseLeave={(e) => {
                //   setHoverImage('image/partner/phone.svg');
                // }}
              >
                <p className="text-2xl font-semibold text-[#010103]/80 hover:text-[#e9be5a]">
                  {getLocaleString('gift_gold', locale)}
                </p>
                <p className="text-[#010103]/54 py-2 text-base font-normal">
                  {getLocaleString('gift_gold_details', locale)}
                </p>
              </div>
              <div className="pt-6 lg:pt-12">
                <Link
                  to={`/${locale}/services`}
                  className="py-4 text-base font-semibold rounded-lg bg-gradient-to-r from-[#e9be5a] to-[#c6952c] hover:bg-gradient-to-br focus:outline-none px-14 text-primary hover:bg-primary hover:text-white"
                >
                  {getLocaleString('learn_more', locale)}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurPartner;
